import { Box, Typography, Grid } from "@mui/material";
import { useDuesSponsoredOrgContext } from '../../global/hooks/useDuesSponsoredOrgContext';
import { useUserInfoContext } from '../../global/hooks/useUserInfoContext';
import { useIlpContext } from '../hooks/useIlpContext';
import OrganizationSelector from "./OrganizationSelector";

//This component is responsible for rendering the program name. 
export default function ProgramBlock() {
    const { organizations, selectedOrganization } = useDuesSponsoredOrgContext();
    const { userInfo } = useUserInfoContext();
    const { standAloneOrg } = useIlpContext();


    // If there's no selected organization, don't render the component.
    if (!selectedOrganization) return null;

    // Directly render the organization name and subtype code if available
    return (
        <Box sx={{paddingTop: 2, paddingBottom: 2}}>
            <Box sx={{padding: 2, bgcolor: '#F6F8F9'}}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2 }} columns={{ xs: 4, sm: 8, md: 7, lg: 12, xl: 12 }} style={{ display: 'flex' }}>
                    <Grid item key={userInfo?.CustomerKey} style={{ display: 'flex' }} xs={12} sm={6} md={6}>
                        <Typography variant="h5" color="black" component="div" sx={{ paddingLeft: 1 }}>{userInfo?.FirstName + " " + userInfo?.LastName}</Typography>
                    </Grid>
                    {(organizations?.length! == 1 && standAloneOrg === undefined) &&
                        <Grid item key={selectedOrganization.OrganizationKey} style={{ display: 'flex' }} xs={12} sm={6} md={6}>
                            <Typography variant="h5" color="black" component="div" sx={{ paddingLeft: 1 }}>{selectedOrganization.Name}</Typography>
                        </Grid>
                    }
                    {(organizations?.length! > 1 || (organizations?.length! === 1 && standAloneOrg !== undefined)) && <OrganizationSelector />}
                </Grid>
            </Box>
        </Box>
    );
}